export default __webpack_public_path__ + "static/polygon-logo-7624d911e068faf1f53719ec4f996036.png";